const Certifications = () => {
  return null
}

export default Certifications
